/** Secciones de la wiki y dónde vive su edición en el admin. */
export const SECTION_HR = "rrhh";
export const SECTION_RECRUITMENT = "recruitment";
export const SECTION_BILLING = "billing";
export const SECTION_SYSTEM = "system";
export const SECTION_ACCOUNTING = "accounting";
export const SECTION_MARKETING = "marketing";
export const SECTION_COMPLIANCE = "compliance";

const ADMIN_PATHS: Record<string, string> = {
	[SECTION_HR]: "/app/admin/employee/wiki",
	[SECTION_RECRUITMENT]: "/app/admin/recruitment/wiki",
	[SECTION_BILLING]: "/app/admin/billing/wiki",
	[SECTION_SYSTEM]: "/app/admin/config/wiki",
	[SECTION_ACCOUNTING]: "/app/admin/accounting/wiki",
	[SECTION_MARKETING]: "/app/admin/marketing/wiki",
	[SECTION_COMPLIANCE]: "/app/admin/compliance/wiki",
};

export const SECTION_LABELS: Record<string, string> = {
	[SECTION_HR]: "RR. HH.",
	[SECTION_RECRUITMENT]: "Selección",
	[SECTION_BILLING]: "Facturación",
	[SECTION_SYSTEM]: "Configuración",
	[SECTION_ACCOUNTING]: "Contabilidad",
	[SECTION_MARKETING]: "Marketing",
	[SECTION_COMPLIANCE]: "Compliance",
};

/** Listado de páginas de la sección en el admin. */
export const wikiAdminListPath = (section: string) => ADMIN_PATHS[section] || ADMIN_PATHS[SECTION_HR];

/** Ficha de edición de una página. */
export const wikiAdminEditPath = (section: string, id: number) => `${wikiAdminListPath(section)}/${id}`;

/** Lectura de una página en el portal del empleado (necesita código y estar visible). */
export const wikiReaderPath = (section: string, code: string) => `/app/employee/wiki/${section}/${code}`;
